import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#0A0A0A]/80 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-215">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-216">
        <a href="#" className="cursor-pointer bg-black rounded-sm p-1" data-id="element-217">
          <img src="https://cdn.magicpatterns.com/uploads/rBHD8bTXffpvN8g1C1ES7H/PCS_Logo.png" alt="PCS – Websites & Content Studio" className="h-10 w-auto" data-id="element-218" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-219">
          <a href="#framework" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-220">
            Framework
          </a>
          <a href="#services" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-221">
            Services
          </a>
          <a href="#faq" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-222">
            FAQ
          </a>
          <a href="#contact" className="text-sm font-medium text-neutral-400 hover:text-white transition-colors" data-id="element-223">
            Contact
          </a>
          <a href="#contact" className="text-sm font-medium bg-white text-black px-5 py-2.5 rounded-sm hover:bg-neutral-200 transition-colors" data-id="element-224">
            Book Strategy Call
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-neutral-400 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-225">
          {mobileMenuOpen ? <X size={24} data-id="element-226" /> : <Menu size={24} data-id="element-227" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-[#0A0A0A] border-b border-white/10 p-6 flex flex-col gap-4 shadow-2xl" data-id="element-228">
          <a href="#framework" className="text-base font-medium text-neutral-300 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-229">
            Framework
          </a>
          <a href="#services" className="text-base font-medium text-neutral-300 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-230">
            Services
          </a>
          <a href="#faq" className="text-base font-medium text-neutral-300 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-231">
            FAQ
          </a>
          <a href="#contact" className="text-base font-medium text-neutral-300 py-2" onClick={() => setMobileMenuOpen(false)} data-id="element-232">
            Contact
          </a>
          <a href="#contact" className="text-base font-medium bg-blue-600 text-white px-5 py-3 rounded-sm text-center mt-2" onClick={() => setMobileMenuOpen(false)} data-id="element-233">
            Book Strategy Call
          </a>
        </div>}
    </motion.nav>;
}